<template>
    <div class="h-screen p-8 flex flex-col items-start bg-gray-100">
        <div class="flex flex-col justify-center gap-y-4 flex-1">
            <p class=text-2xl>{{error.statusCode}}</p>
            <h1 class="text-4xl font-extrabold">Page Not Found</h1>

            <hr class="w-1/3 my-2" />

            <p>The page you are looking for does not exist.</p>
            <p>If you think there is an error please contact support.</p>

            <div class="flex mt-8 space-x-4">
              <NuxtLink :to="`${config.public.boardDomain}/accounts`" class="w-fit p-2 px-3 flex items-center justify-center gap-1 rounded-md bg-primary hover:bg-primary-dark disabled:bg-primary-soft text-white">
                  <font-awesome :icon="['fas', 'home']" />
                  Home
              </NuxtLink>
              <NuxtLink to="mailto:support@boardable.com" class="w-fit p-2 px-3 flex items-center justify-center gap-1 rounded-md border-gray-400 hover:bg-gray-200 text-black bg-white border">
                  <font-awesome :icon="['far', 'envelope']" />
                  Contact Support
              </NuxtLink>
            </div>
        </div>
        <NuxtLink :to="`${config.public.boardDomain}/accounts`">
            <nuxt-img class="h-8" src="/boardable-logo-next.svg"></nuxt-img>
        </NuxtLink>
    </div>
</template>

<script setup lang="ts">
    import type { NuxtError } from "#app";

    const { error } = defineProps<{
        error: NuxtError
    }>()

    const config = useRuntimeConfig()
</script>
